import { useContext, useMemo } from 'react';
import useBranches from '@ubeya/shared/hooks/account/useBranches';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import ConfigContext from '../contexts/ConfigContext';
import {
  POSITIONS_SETTINGS_ALL_BRANCHES,
  POSITIONS_SETTINGS_COMPLIANCE,
  POSITIONS_SETTINGS_FILTERS_SLUGS
} from '../constants';

const usePositionsSettingsFilterOptions = () => {
  const { t } = useContext(ConfigContext);
  const { branchesOptions } = useBranches();

  return useMemo(
    () => ({
      [POSITIONS_SETTINGS_FILTERS_SLUGS.branches]: [
        { value: POSITIONS_SETTINGS_ALL_BRANCHES, label: t('allBranches') },
        ...[...(branchesOptions || [])].sort(SORT_BY_STRING('label'))
      ],
      [POSITIONS_SETTINGS_FILTERS_SLUGS.compliance]: [
        { value: POSITIONS_SETTINGS_COMPLIANCE.WITH, label: t('withCompliance') },
        { value: POSITIONS_SETTINGS_COMPLIANCE.WITHOUT, label: t('withoutCompliance') }
      ]
    }),
    [branchesOptions, t]
  );
};

export default usePositionsSettingsFilterOptions;
